import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchTeachersAsync,
  selectAllTeachers,
} from "../../../Slices/teachersSlice";
import {
  fetchTimeIntervalsAsync,
  selectAllTimeIntervals,
} from "../../../Slices/timeIntervalsSlice";
import {
  fetchSubjectsAsync,
  selectAllSubjects,
} from "../../../Slices/subjectsSlice";
import {
  classSchedule,
  updateClassSchedule,
} from "../../../ApiService/ApiService";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  IconButton,
  CircularProgress,
  Typography,
} from "@mui/material";
import {
  CalendarToday,
  AccessTimeFilled,
  Man,
  Subject,
  AddCircle,
  AdminPanelSettings,
  DeleteOutline,
} from "@mui/icons-material";
import CustomDialog from "../../../Components/CustomDialog";

function AddSchedule({ classId, schoolId, setActionComponent, classes }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchTeachersAsync());
    dispatch(fetchTimeIntervalsAsync());
    dispatch(fetchSubjectsAsync());
  }, [dispatch]);
  const teachers = useSelector(selectAllTeachers);
  const timeIntervals = useSelector(selectAllTimeIntervals);
  const subjects = useSelector(selectAllSubjects);

  const [scheduledClasses, setScheduledClasses] = useState([]);
  const [dayId, setDayId] = useState(-1);
  const [timeIntervalId, setTimeIntervalId] = useState(-1);
  const [teacherId, setTeacherId] = useState(-1);
  const [subjectId, setSubjectId] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    message: "",
    buttons: [],
  });

  const ClassName = classes?.data?.find((classObj) => classObj.id === classId);
  const fullClassName = ClassName
    ? ` ${ClassName.grade} - ${ClassName.section}`
    : "";

  const headCells = [
    { id: "Day", label: "Day", icon: <CalendarToday sx={{ mr: 1 }} /> },
    {
      id: "timeinterval",
      label: "Time Interval",
      icon: <AccessTimeFilled sx={{ mr: 1 }} />,
    },
    { id: "subject", label: "Subject", icon: <Subject sx={{ mr: 1 }} /> },
    {
      id: "teacher",
      label: "Subject Teacher",
      icon: <Man sx={{ mr: 1 }} />,
    },
    {
      id: "actions",
      label: "Actions",
      icon: <AdminPanelSettings sx={{ mr: 1 }} />,
    },
  ];

  const days = [
    { id: -1, name: "Select Day" },
    { id: 0, name: "Monday" },
    { id: 1, name: "Tuesday" },
    { id: 2, name: "Wednesday" },
    { id: 3, name: "Thursday" },
    { id: 4, name: "Friday" },
    { id: 5, name: "Saturday" },
    { id: 6, name: "Sunday" },
  ];

  const handleDialogClose = () => {
    setDialog({ ...dialog, visible: false });
  };

  const fetchScheduledClasses = async () => {
    setLoading(true);
    try {
      const response = await classSchedule({
        classId: classId,
        schoolId: schoolId,
      });
      // console.log("RES", response?.data);
      const sortedSchedule = response?.data?.data?.schedule?.sort((a, b) => {
        if (a.dayId !== b.dayId) {
          return a.dayId - b.dayId;
        } else {
          const aStartTime = a.day_schedule[0].timeIntervalId;
          const bStartTime = b.day_schedule[0].timeIntervalId;
          return aStartTime - bStartTime;
        }
      });
      setScheduledClasses(sortedSchedule);
    } catch (error) {
      console.error("Error fetching scheduled classes:", error);
      setDialog({
        visible: true,
        title: "Error",
        message: "Failed to fetch schedule",
        buttons: [{ name: "OK", onPress: handleDialogClose }],
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchScheduledClasses();
  }, [classId, schoolId]);

  const resetFormState = () => {
    setDayId(-1);
    setTimeIntervalId(-1);
    setTeacherId(-1);
    setSubjectId(-1);
  };

  // Handle AddSchedule
  // const handleAddSchedule = () => {
  //   if (
  //     dayId === -1 ||
  //     timeIntervalId === -1 ||
  //     subjectId === -1 ||
  //     teacherId === -1
  //   ) {
  //     console.log("Please select a valid option..");
  //     setDialog({
  //       visible: true,
  //       title: "Error",
  //       message: "Please select a valid option",
  //       buttons: [{ name: "OK", onPress: handleDialogClose }],
  //     });
  //     return;
  //   }

  //   const existingScheduleIndex = scheduledClasses?.findIndex(
  //     (schedule) => schedule.dayId === dayId
  //   );
  //   if (existingScheduleIndex && existingScheduleIndex !== -1) {
  //     const updatedScheduledClasses = [...scheduledClasses];
  //     updatedScheduledClasses[existingScheduleIndex].day_schedule.push({
  //       timeIntervalId: timeIntervalId,
  //       subjectId: subjectId,
  //       teacherId: teacherId,
  //     });
  //     setScheduledClasses(updatedScheduledClasses);
  //     setDialog({
  //       visible: true,
  //       title: "Success",
  //       message: "Class scheduled successfully",
  //       buttons: [{ name: "OK", onPress: handleDialogClose }],
  //     });
  //   } else {
  //     setScheduledClasses((prevScheduledClasses) => [
  //       ...(prevScheduledClasses || []),
  //       {
  //         dayId: dayId,
  //         day_schedule: [
  //           {
  //             timeIntervalId: timeIntervalId,
  //             subjectId: subjectId,
  //             teacherId: teacherId,
  //           },
  //         ],
  //       },
  //     ]);
  //     setDialog({
  //       visible: true,
  //       title: "Success",
  //       message: "Class scheduled successfully",
  //       buttons: [{ name: "OK", onPress: handleDialogClose }],
  //     });
  //   }
  //   resetFormState();
  // };

  const handleAddSchedule = () => {
    if (
      dayId === -1 ||
      timeIntervalId === -1 ||
      subjectId === -1 ||
      teacherId === -1
    ) {
      console.log("Please select a valid option..");
      setDialog({
        visible: true,
        title: "Error",
        message: "Please select a valid option",
        buttons: [{ name: "OK", onPress: handleDialogClose }],
      });
      return;
    }

    const existingScheduleIndex = scheduledClasses?.findIndex(
      (schedule) => schedule.dayId === dayId
    );

    if (existingScheduleIndex !== -1 && existingScheduleIndex !== undefined) {
      const updatedScheduledClasses = [...scheduledClasses];
      updatedScheduledClasses[existingScheduleIndex].day_schedule.push({
        timeIntervalId: timeIntervalId,
        subjectId: subjectId,
        teacherId: teacherId,
      });
      setScheduledClasses(updatedScheduledClasses);
      setDialog({
        visible: true,
        title: "Success",
        message: "Class scheduled successfully",
        buttons: [{ name: "OK", onPress: handleDialogClose }],
      });
    } else {
      setScheduledClasses((prevScheduledClasses) => [
        ...(prevScheduledClasses || []),
        {
          dayId: dayId,
          day_schedule: [
            {
              timeIntervalId: timeIntervalId,
              subjectId: subjectId,
              teacherId: teacherId,
            },
          ],
        },
      ]);
      setDialog({
        visible: true,
        title: "Success",
        message: "Class scheduled successfully",
        buttons: [{ name: "OK", onPress: handleDialogClose }],
      });
    }
    resetFormState();
  };


  // Handle DeleteSchedule
  const handleDeleteItem = (dayId, timeIntervalId, subjectId, teacherId) => {
    setLoading(true);
    const updatedScheduledClasses = scheduledClasses.map((scheduledClass) => {
      if (scheduledClass.dayId === dayId) {
        const updatedDaySchedule = scheduledClass.day_schedule.filter(
          (scheduleItem) =>
            scheduleItem.timeIntervalId !== timeIntervalId ||
            scheduleItem.subjectId !== subjectId ||
            scheduleItem.teacherId !== teacherId
        );
        return {
          ...scheduledClass,
          day_schedule: updatedDaySchedule,
        };
      }
      return scheduledClass;
    });
    console.log(updatedScheduledClasses);
    setScheduledClasses(updatedScheduledClasses);
    setDialog({
      visible: true,
      title: "Success",
      message: "Class schedule deleted",
      buttons: [{ name: "OK", onPress: handleDialogClose }],
    });
    setLoading(false);
  };

  // Handle UpdateSchedule
  const handleUpdate = async (event) => {
    event.preventDefault();
    const newScheduleData = {
      schoolId: schoolId,
      classId: classId,
      schedule: scheduledClasses,
    };
    setLoading(true);
    try {
      const response = await updateClassSchedule(newScheduleData);
      if (response) {
        if (response?.data?.status === 200) {
          setDialog({
            visible: true,
            title: "Success",
            message: "Class scheduled updated",
            buttons: [{ name: "OK", onPress: handleDialogClose }],
          });
        } else {
          const errorMessage =
            response?.data?.errorMessage || "Something went wrong";
          setDialog({
            visible: true,
            title: "Error",
            message: errorMessage,
            buttons: [{ name: "Close", onPress: handleDialogClose }],
          });
          return;
        }
      } else {
        setDialog({
          visible: true,
          title: "Error",
          message: "Invalid response from the server",
          buttons: [{ name: "Close", onPress: handleDialogClose }],
        });
        return;
      }
    } catch (error) {
      console.log("Error in updating schedule", error);
      setDialog({
        visible: true,
        title: "Error",
        message: "Failed to add schedule",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
      return;
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomDialog
        visible={dialog.visible}
        title={dialog.title}
        message={dialog.message}
        buttons={dialog.buttons}
        onClose={handleDialogClose}
      />
      <Box>
        <Typography
          paragraph
          sx={{
            fontWeight: 600,
            fontSize: 22,
            fontFamily: "Barlow, sans-serif",
            marginBottom: 1,
          }}
        >
          Schedule for {fullClassName}
        </Typography>

        <TableContainer
          component={Paper}
          sx={{ height: "500px", overflow: "auto" }}
        >
          <Table size="medium">
            <TableHead>
              <TableRow>
                {headCells.map((headCell) => (
                  <TableCell key={headCell.id} align="left" padding="normal">
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {headCell.icon}
                      {headCell.label}
                    </Box>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <FormControl fullWidth size="small">
                    <InputLabel id="days">Day</InputLabel>
                    <Select
                      name="dayId"
                      label="Day"
                      labelId="days"
                      value={dayId}
                      onChange={(e) => setDayId(e.target.value)}
                      size="small"
                    >
                      {days?.map((day) => (
                        <MenuItem key={day.id} value={day.id}>
                          {day.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  <FormControl fullWidth size="small">
                    <InputLabel id="timeinterval">Time Interval</InputLabel>
                    <Select
                      name="timeIntervalId"
                      label="Time Interval"
                      labelId="timeinterval"
                      value={timeIntervalId}
                      onChange={(e) => setTimeIntervalId(e.target.value)}
                      size="small"
                    >
                      <MenuItem value={-1}>Select Time Interval</MenuItem>
                      {timeIntervals?.data?.map((interval) => (
                        <MenuItem key={interval.id} value={interval.id}>
                          {interval.startTime} - {interval.endTime}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  <FormControl fullWidth size="small">
                    <InputLabel id="subject">Subject</InputLabel>
                    <Select
                      name="subjectId"
                      label="Subject"
                      labelId="subject"
                      value={subjectId}
                      onChange={(e) => setSubjectId(e.target.value)}
                      size="small"
                    >
                      <MenuItem value={-1}>Select Subject</MenuItem>
                      {subjects?.data?.map((subject) => (
                        <MenuItem key={subject.id} value={subject.id}>
                          {subject.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  <FormControl fullWidth size="small">
                    <InputLabel id="subteacher">Teacher</InputLabel>
                    <Select
                      name="teacherId"
                      label="Teacher"
                      labelId="subteacher"
                      value={teacherId}
                      onChange={(e) => setTeacherId(e.target.value)}
                      size="small"
                    >
                      <MenuItem value={-1}>Select Teacher</MenuItem>
                      {teachers?.data?.map((teacher) => (
                        <MenuItem key={teacher.id} value={teacher.id}>
                          {teacher.firstName} {teacher.lastName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  <IconButton onClick={handleAddSchedule} size="small">
                    <AddCircle />
                  </IconButton>
                </TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : (
              <TableBody>
                {scheduledClasses
                  ?.filter(
                    (scheduledClass) => scheduledClass?.day_schedule.length > 0
                  )
                  ?.map((scheduledClass, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">
                        {scheduledClass?.day_schedule.length > 0 && (
                          <Typography
                            variant="body1"
                            sx={{ marginBottom: 1, fontSize: 14 }}
                          >
                            {
                              days.find(
                                (day) => day.id === scheduledClass.dayId
                              )?.name
                            }
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {scheduledClass?.day_schedule?.length > 0 &&
                          scheduledClass?.day_schedule?.map(
                            (scheduleItem, index) => (
                              <Typography
                                variant="body1"
                                key={index}
                                sx={{ marginBottom: 1, fontSize: 14 }}
                              >
                                {`${
                                  timeIntervals?.data?.find(
                                    (interval) =>
                                      interval.id ===
                                      scheduleItem.timeIntervalId
                                  )?.startTime
                                } to ${
                                  timeIntervals?.data?.find(
                                    (interval) =>
                                      interval.id ===
                                      scheduleItem.timeIntervalId
                                  )?.endTime
                                }`}
                              </Typography>
                            )
                          )}
                      </TableCell>
                      <TableCell align="center">
                        {scheduledClass?.day_schedule?.length > 0 &&
                          scheduledClass?.day_schedule?.map(
                            (scheduleItem, index) => (
                              <Typography
                                variant="body1"
                                key={index}
                                sx={{ marginBottom: 1, fontSize: 14 }}
                              >
                                {
                                  subjects?.data?.find(
                                    (subject) =>
                                      subject.id === scheduleItem.subjectId
                                  )?.name
                                }
                              </Typography>
                            )
                          )}
                      </TableCell>
                      <TableCell align="center">
                        {scheduledClass?.day_schedule?.length > 0 &&
                          scheduledClass?.day_schedule?.map(
                            (scheduleItem, index) => (
                              <Typography
                                key={index}
                                variant="body1"
                                sx={{ marginBottom: 1, fontSize: 14 }}
                              >
                                {`${
                                  teachers?.data?.find(
                                    (teacher) =>
                                      teacher.id === scheduleItem.teacherId
                                  )?.firstName
                                } ${
                                  teachers?.data?.find(
                                    (teacher) =>
                                      teacher.id === scheduleItem.teacherId
                                  )?.lastName
                                }`}
                              </Typography>
                            )
                          )}
                      </TableCell>
                      <TableCell>
                        {scheduledClass?.day_schedule?.length > 0 &&
                          scheduledClass?.day_schedule?.map(
                            (scheduleItem, index) => (
                              <Box
                                key={index}
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <IconButton
                                  size="small"
                                  color="error"
                                  onClick={() =>
                                    handleDeleteItem(
                                      scheduledClass.dayId,
                                      scheduleItem.timeIntervalId,
                                      scheduleItem.subjectId,
                                      scheduleItem.teacherId
                                    )
                                  }
                                >
                                  <DeleteOutline fontSize="small" />
                                </IconButton>
                              </Box>
                            )
                          )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            )}
          </Table>
        </TableContainer>

        <Box
          sx={{
            marginTop: 2,
            display: "flex",
            alignContent: "space-evenly",
          }}
        >
          <Button
            variant="contained"
            color="inherit"
            sx={{ textTransform: "unset" }}
            onClick={() => setActionComponent(null)}
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpdate}
            disabled={loading}
            sx={{ marginLeft: 1, textTransform: "unset" }}
          >
            {loading ? "Loading.." : "Update"}
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default AddSchedule;
